/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useStaticQuery, graphql } from "gatsby";
import Helmet from "react-helmet";
// import Header from "./header";
import "./layout.css";
const Layout = ({ children, brand }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `);
  useEffect(() => {
    var link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.getElementsByTagName("head")[0].appendChild(link);
    }
    if (brand) {
      link.href = brand?.icon?.localFile?.publicURL;
    } else {
      link.href = "/favicon.png";
    }
  }, [brand]);

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />

        <title>
          {brand
            ? brand?.brandName.replace(/\w\S*/g, function(txt) {
                return (
                  txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
                );
              })
            : data?.site?.siteMetadata?.title
            ? data.site.siteMetadata.title
            : "My site"}
        </title>

        <meta
          data-react-helmet="true"
          name="description"
          content={
            brand?.brandTag[0].toUpperCase() + brand?.brandTag.substring(1)
          }
        />
        <meta
          data-react-helmet="true"
          name="image"
          content={ brand?.brandPath?"https://search.trysidedoor.com/" +brand?.icon?.localFile?.publicURL:"/social.png" }
        />

        {/* OpenGraph tags */}
        <meta
          data-react-helmet="true"
          property="og:url"
          content={"https://search.trysidedoor.com/" + brand?.brandPath}
        />
        <meta
          data-react-helmet="true"
          property="og:title"
          content={brand?.brandName.replace(/\w\S*/g, function(txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
          })}
        />
        <meta
          data-react-helmet="true"
          property="og:description"
          content={
            brand?.brandTag[0].toUpperCase() + brand?.brandTag.substring(1)
          }
        />
        <meta
          data-react-helmet="true"
          property="og:image"
          content={ brand?.brandPath?"https://search.trysidedoor.com/" +brand?.icon?.localFile?.publicURL:"social.png" }
        />

        {/* Twitter Card tags */}
        <meta
          data-react-helmet="true"
          name="twitter:card"
          content="summary_large_image"
        />
        <meta
          data-react-helmet="true"
          name="twitter:title"
          content={brand?.brandName.replace(/\w\S*/g, function(txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
          })}
        />
        <meta
          data-react-helmet="true"
          name="twitter:description"
          content={
            brand?.brandTag[0].toUpperCase() + brand?.brandTag.substring(1)
          }
        />
        <meta
          data-react-helmet="true"
          name="twitter:image"
          content={ brand?.brandPath?"https://search.trysidedoor.com/" +brand?.icon?.localFile?.publicURL:"social.png" }
        />
      </Helmet>
      <div
        style={{
          margin: `0 auto`,
          // maxWidth: 1170,
          // padding: `0 `,
          paddingTop: 0
        }}
      >
        <main>{children}</main>
      </div>
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired
};

export default Layout;
